import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {userAuditLogStateSelector} from './user-audit-log-state.slice';

import type {UserAuditLogCriteria} from '../typedef';
import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {LogHits} from 'src/openapi/admin/models/LogHits';


export const userAuditLogSlice = getCachedTableDataSlice<
    LogHits[],
    undefined,
    undefined,
    UserAuditLogCriteria
>('userAuditLog');

export const userAuditLogActions = userAuditLogSlice.actions;
const userAuditLogCacheSelector: CachedTableCacheSelector<LogHits[]>
    = state => state.userPage.tabs.userAuditLog.events.cache;
export const userAuditLogDataSelector: CachedTableDataSelector<LogHits[]>
    = state => state.userPage.tabs.userAuditLog.events;
export const userAuditLogResultSelector = getCachedTableResultSelector(
    userAuditLogCacheSelector,
    userAuditLogStateSelector,
);
